export default __webpack_public_path__ + "static/media/Karekter-2.5fae7b19.png";